<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiArrowRight } from "@mdi/js";
export default {
  name: "MdiArrowRight",
  data() {
    return {
      svgPath: mdiArrowRight,
    };
  },
};
</script>
